import { Block, Button, useStyletron } from "@mezo-org/mezo-clay"

import { useBorrowForm } from "#/shared/hooks"
import { ComponentStepProps } from "#/ui/Modal"

import { BorrowProgress } from "../components"

import { BorrowGas, BorrowInputs, BorrowReward } from "./components"

export default function BorrowForm({ onClickContinue }: ComponentStepProps) {
  const [css, theme] = useStyletron()

  const { isLoanValid } = useBorrowForm()

  return (
    <>
      <BorrowProgress step={1} stepsCount={4} />
      <Block
        className={css({
          flexDirection: "column",
          display: "flex",
          gap: theme.sizing.scale300,
          padding: theme.sizing.scale800,
          paddingTop: 0,
          height: "100%",
        })}
      >
        <BorrowInputs />
        <BorrowGas />

        <BorrowReward />
        <Button
          size="large"
          onClick={onClickContinue}
          disabled={!isLoanValid}
          data-attr="borrow-review_cta-step_2"
        >
          Review
        </Button>
      </Block>
    </>
  )
}
